var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(
    _vm.feather.icons[_vm.name].toSvg(Object.assign({}, {color: _vm.color,
      class: 'Icon',
      width: _vm.variableSize,
      height: _vm.variableSize,
      'stroke-width': 3},
      _vm.options))
  )}})}
var staticRenderFns = []

export { render, staticRenderFns }